var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticStyle:{"white-space":"nowrap"}},_vm._l((_vm.segments),function(segment){return _c('formatted-content',{attrs:{"segment":segment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }